import api from '@/api'
import {dateStringFrom} from '@/utils'

export default {
  getCourseList (context, { expectTimeBegin, expectTimeEnd, pageIndex, pageSize }) {
    return api.course.getCourseList({ expectTimeBegin, expectTimeEnd, pageIndex, pageSize })
  },
  getSystemCourseList (context, { systemMark, userId }) {
    return api.course.getSystemCourseList({ userId }, { paths: { systemMark } })
  },
  getCourseDetail (context, { courseId, from }) {
    return api.course.getCourseDetail({ courseId, from }).then(course => {
      course.dateString = `${dateStringFrom(
        'M 月 D 日，hh:mm',
        course.expectStartTime
      )} - ${dateStringFrom(
        'hh:mm',
        course.expectStartTime + course.expectTime
      )}`

      return course
    })
  },
  getCourseData (context, { courseId }) {
    return api.course.getCourseData({ courseId }).then(course => {
      course.dateString = `${dateStringFrom(
        'M 月 D 日，hh:mm',
        course.expectStartTime
      )} - ${dateStringFrom(
        'hh:mm',
        course.expectStartTime + course.expectTime
      )}`

      return course
    })
  },
  getCourseFiles ({ commit }, { courseId }) {
    return api.file.getCourseFiles(
      {},
      {
        paths: { courseId },
      }
    )
  },
  setCourseSingup (context, { courseId, signUpFlag }) {
    return api.course.setCourseSingup({ courseId, type: signUpFlag ? 1 : 0 })
  },
  downloadCourseFile ({ commit }, { fileName, path, courseId }) {
    return api.course.downloadCourseFile({}, { paths: { courseId } })
  },
  getHomeRecommend () {
    return api.course.getHomeRecommend()
  },
  getHomeList () {
    return api.course.getHomeList()
  },
  getMyCourses () {
    return api.course.getMyCourses({})
  },
  getCoursePosters (context, { source }) {
    return api.file.getCoursePosters({ source })
  },
  setCourseCommend ({ commit }, { content, evaluate, targetId, targetType }) {
    return api.course.setCourseCommend({
      content,
      evaluate,
      targetId,
      targetType,
    })
  },
  async getSignUpDelta ({ commit }, { type, objectId }) {
    let data = await api.user.signUpPower(null, { params: { objectId } })
    commit('setCoinChange', Object.assign({}, data, { type }))
    // 判断等级改变
    commit('setLevelChange', data)
  },
  async getPowerDelta ({ commit }, { type, objectId }) {
    let data = await api.user.getPowerDelta({ objectId })
    commit('setCoinChange', Object.assign({}, data, { type }))
    // 判断等级改变
    commit('setLevelChange', data)
  },
  getRecord ({ commit }, { courseId }) {
    return api.course.getRecord(null, { paths: { courseId } })
  },
  getRecordData ({ commit }, { courseId }) {
    return api.course.getRecordData(null, { paths: { courseId } })
  },
  getVideo ({ commit }, { videoId }) {
    return api.course.getVideo(null, { paths: { videoId } })
  },
  getVideoFromNim ({ commit }, { vid }) {
    return api.course.getVideoFromNim(null, { paths: { vid } })
  },
  getVideos ({ commit }, params) {
    return api.course.getVideos(params)
  },
  addVideoRecord ({ commit }, params) {
    return api.course.addVideoRecord(params)
  },
  getVideoRecord ({ commit }, { courseId, videoId }) {
    return api.course.getVideoRecord(null, { paths: { courseId, videoId } })
  },
  getQuote () { // 获取小阿情话
    return api.course.getQuote()
  },
  getFiscalFilter ({ commit }, params) {
    return api.course.getFiscalFilter(params)
  },
  saveFiscalPhone ({ commit }, params) {
    return api.course.saveFiscalPhone(params)
  },
  getMuteUserList ({ commit }, params) {
    return api.course.getMuteUserList(null, { paths: { roomid: params.roomid } })
  },
  setMuteUser ({ commit }, params) {
    return api.course.setMuteUser(params)
  },
  // 点播答题相关
  getQuestionBank ({ commit }, params) {
    return api.course.getQuestionBank(params)
  },
  submitAnswer ({ commit }, params) {
    return api.course.submitAnswer(params)
  },
  getScore ({ commit }, params) {
    return api.course.getScore(params)
  },
  getCoursePv({commit}, {courseId}) {
    return api.course.getCoursePv(null, {paths: {courseId}}).then(data => {
      commit('updateCoursePv', data)
    })
  },
}
